var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,12A2,2 0 0,1 18,14A2,2 0 0,1 16,16A2,2 0 0,1 14,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,14A2,2 0 0,1 10,16A2,2 0 0,1 8,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,14A2,2 0 0,1 4,16A2,2 0 0,1 2,14A2,2 0 0,1 4,12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.f8d4d9bb072e7c604d8836888d285a9d.svg";
export { ForwardRef as ReactComponent };